export default __webpack_public_path__ + "static/Projetistas-6f690918cca9f688341cdaa8e6754b8e.svg";